import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Grid, Row, Col, OverlayTrigger, Popover, Modal } from "react-bootstrap";
import 'react-confirm-alert/src/react-confirm-alert.css';
import { Card } from "components/Card/Card.jsx";
import 'react-table/react-table.css';
import { SC } from 'helper/ServerCall';
import { hasPermission } from 'helper/hasPermission';
import { adminLabels } from 'redux/constant/admin-label-constant';
import { helperFunctions as HF, closeModal, returnLabelWithValue } from 'helper/helperFunctions';
import Pagination from '../../ThemeComponents/Pagination';
import { getTestimonials } from '../../../redux/actions/testimonials';
import User from '../../../helper/User';
import { alertActions } from '../../../redux/actions/alert-actions';
import EditTestimonialForm from './EditTestimonialForm';
import { getBrands } from "redux/actions/account-action";
import Select from 'react-select';
// var Modal = require('react-bootstrap-modal');

class TestimonialListPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editModalDestination: this.props.editModalDestination,
      sorted: '',
      filtered: '',
      pageSize: 10,
      page: 0,
      is_active: '1',
      selectedId: null,
      brand_id: null,
      selectedBrand: null
    };
    this.toggleModal = HF.toggleModal.bind(this);
    this.props.getBrandsCall();
  };
  paginationCall = (data) => {
    return this.props.getTestimonials(this.state.selectedBrand, data.pageSize, '', '', true)
  }

  updateTestimonialStatus = (id, data) => {
    return SC.postCall('updateTestimonialStatus/' + id, data );
  }

  handleupdateTestimonialStatus = testimonialId => (e) => {
    this.updateTestimonialStatus(testimonialId, { is_active: e.target.checked ? true : false }).then(
      response => {
        this.props.success(response.message);
        this.pagination.dataCall();
      }
    );
  }

  componentDidUpdate(prevProps, prevState) { 
    if (prevState.selectedBrand !== this.state.selectedBrand) {
      this.pagination.dataCall();
    }
  } 
  handleChangeBrand = (selectedOptionType, info) => {
    
    if (info['action'] === 'select-option') {
      this.setState({ brand_id: selectedOptionType.value, selectedBrand: selectedOptionType.domain_slug });
    } else if (info['action'] === 'clear') {
      this.setState({ brand_id: null, selectedBrand: null });
    }

  }
  render() {
    const { brands } = this.props;
    const keywords = ['gtv', 'ttk', 'itk'];

    const filteredBrands = brands.filter(item => 
        keywords.some(keyword => item.domain_slug.includes(keyword))
    );

    const columns = [
      {
        Header: "Testimonial Listing",
        headerClassName: 'headerPagination',
        columns: [
          {
            Header: "Company/Group Name",
            accessor: "company",
            className: "acer"
          },
          {
            Header: "Testimonial",
            accessor: "description",
            className: "acer"
          },
          {
            Header: "Author",
            accessor: "author",
            className: "acer"
          },
          {
            Header: "Brand",
            accessor: "brand.domain_slug",
            className: "acer",
            Cell: ({ value }) => {
                return <span>{value ? value.toUpperCase() : ''}</span>
            }
          },
          {
              Header: "Submitted Date",
              accessor: "createdAtString",
              className: "action-center"
          },
          {
            Header: "Status",
            accessor: "id",
            Cell: ({ row, original}) => (
              <label className="container-check">
                &nbsp;
                <input type="checkbox" name="is_active" className="checkbox" value={original.is_active ? true : false} onChange={this.handleupdateTestimonialStatus(original.id)} checked={original.is_active ? true : false}
                  readOnly={true} /><span className="checkmark"></span>
              </label>
            ),
          
            className: "action-center",
            sortable: false
          },
          {
            Header: "Actions",
            accessor: "id",
            Cell: ({ value }) => (
              <div>
                <OverlayTrigger placement="bottom" overlay={<Popover id="tooltip">{hasPermission('destination-edit') ? 'Edit Testimonial' : adminLabels.DONT_ALLOW}</Popover>}>
                  <span>
                    {
                      hasPermission('destination-edit') &&
                      <button type='button' className="editIcon orderDetailsAction" onClick={() => { this.setState({ editModalDestination: !this.state.editModalDestination, selectedId: value}) }}>&nbsp;</button>
                    }
                    {
                      !hasPermission('destination-edit') &&
                      <button type='button' className="editIcon orderDetailsAction button_disabled" >&nbsp;</button>
                    }
                  </span>
                </OverlayTrigger>
              </div>
            ),
            className: "action-center",
            sortable: false
          }
        ]
      }
    ];
    
    return (
      <div className="content">
        <Grid fluid>
          <Row>
            <Col md={12}>
              <Card
                ctTableResponsive
                content={
                  <div>
                    <Grid fluid>
                      <Row>
                        <Col md={12}>
                          <div className="secHeading">
                            Testimonials List
                          </div>
                        </Col>
                        <Col md={12}>
                          <div className='col-md-3'>
                            <div className="form-group">
                              <label htmlFor="glemail">Select Brand</label>
                              <Select
                                value={returnLabelWithValue(this.state.brand_id, filteredBrands)}
                                onChange={this.handleChangeBrand}
                                options={filteredBrands}
                                isSearchable={true}
                                name='account_id'
                                placeholder={'Select Brand'}
                                isClearable={true}
                                />
                            </div>
                          </div>
                        </Col>
                        <Pagination
                          ref={(p) => this.pagination = p}
                          showPagination={false}
                          columns={columns}
                          pageSize={10}
                          getDataCall={this.paginationCall}
                          // filterView={true}
                          noDataText='No Testimonials found'
                         
                          // filterPlaceHolder={'Testimonials'}
                          getRowProps={this.getRowProps}
                        />
                      </Row>
                    </Grid>


                    {/*Edit Destination Modal start*/}
                    {
                      this.state.editModalDestination &&
                      <Modal bsSize="lg" backdrop={'static'} show={this.state.editModalDestination} id="" onHide={closeModal.bind(this, "editModalDestination")} aria-labelledby="ModalHeader" className="" >
                          <Modal.Header closeButton>
                              <Modal.Title id='ModalHeader' className="headerTitle">Edit Testimonial</Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                              <div className="container table-responsive mt-xlg">
                                  <EditTestimonialForm id={this.state.selectedId} paginationCall={this.pagination.dataCall} closeModal={closeModal.bind(this, "editModalDestination")}/>
                              </div>
                          </Modal.Body>
                      </Modal>
                      
                    }
                    {/*Edit Destination Modal End*/}
                  </div>
                } />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  };
};

const mapDispatchToProps = dispatch => {
  return ({
    getTestimonials: (brand_id, pageSize, sort, filter, is_admin) => { return dispatch(getTestimonials(brand_id, pageSize, sort, filter, is_admin)) },
    success: (message) => { return dispatch(alertActions.success(message)) },
    getBrandsCall: () => { dispatch(getBrands())}
  });
};

function mapStateToProps(state) {
    const { brands } = state.accountReducer;
  return {
    brands
  };
};

const TestimonialList = connect(mapStateToProps, mapDispatchToProps)(TestimonialListPage);
export default TestimonialList;
